'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFormatClear = function MdFormatClear(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 8.4h23.4v5h-9.7l-2.7 6.2-3.5-3.4 1.2-2.8h-4l-4.7-4.7v-0.3z m-4.5 0l0.4 0.4 24.1 24.1-2.1 2.1-9.5-9.5-2.5 6.1h-5l4-9.6-11.5-11.5z' })
        )
    );
};

exports.default = MdFormatClear;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/format-clear.js
// module id = 767
// module chunks = 0